'use strict';

/**
 * Job Ad Options
 *
 * @type {{view: waApp.controllers.JobCredits.view}}
 */
waApp.controllers.JobAdOptions = {

	togglePaymentDetails: function() {
		let options = $('#job-post-options input[type=checkbox]:checked');
		let paymentDetails = $('#options-payment-details');
		let purchaseButton = $('#purchase-button');

		if (options.length > 0) {
			paymentDetails.fadeIn('slow');
			purchaseButton.show();
		} else {
			paymentDetails.hide();
			purchaseButton.hide();
		}
	},

	updateCheckoutSummary: function() {
		let preview = $('#checkout-preview');
		let loading = $('#checkout-loading');

		preview.fadeOut('fast', function() {
			loading.fadeIn('fast');
		});

		$.ajax({
			type: 'POST',
			url: waApp.getLanguage() + '/job-ad-options/checkout-preview',
			data: $('#job-post-option-form').serialize(),
			dataType: 'html'
		})
		.done(function(data) {
			preview.html(data);

			setTimeout(function() {
				loading.fadeOut('slow', function() {
					preview.fadeIn('fast');
				});
			}, 500);
		});
	},

	view: function() {
		let form = $('#job-post-option-form');

		let purchaseButton = $('#purchase-button');

		purchaseButton.on('click', function() {
			if ($('#payment-method-id').val() != 6) {
				$('#credit-card-inputs').remove();
			}

			form.submit();
		});

		form.on('click', '#job-post-options', 'input', function() {
			waApp.controllers.JobAdOptions.updateCheckoutSummary();
		});

		form.on('change', '#company-id', function() {
			waApp.controllers.JobAdOptions.updateCheckoutSummary();
		});

		let stripeHelper = new StripeFormHelper(form);

		let paymentMethodHelper = new PaymentMethodFormHelper(form);

		paymentMethodHelper.initialize();

		form.on('submit', function(event) {
			// Disable the submit button to prevent repeated clicks
			purchaseButton.prop('disabled', true);

			if ($('#payment-method-id').val() == 6) {
				event.preventDefault();

				stripeHelper.createToken();
			}

			return true;
		});

		setTimeout(waApp.controllers.JobAdOptions.togglePaymentDetails, 1000);
	}
};
